import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=b59479ce&scoped=true&"
import script from "./CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=b59479ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59479ce",
  null
  
)

export default component.exports